export const initShareComponent = () => {
  const copyLinkButton = document.querySelector('[data-share-copy]');

  if (!copyLinkButton) {
    return;
  }

  copyLinkButton.addEventListener('click', (e) => {
    e.preventDefault();
    const url = copyLinkButton.getAttribute('data-url');
    const iconWrapper = copyLinkButton.querySelector('[data-icon-wrapper]');

    if (!iconWrapper || !url) {
      return;
    }

    const originalIcon = iconWrapper.innerHTML;

    navigator.clipboard
      .writeText(url)
      .then(() => {
        // Show check icon
        iconWrapper.innerHTML = `
                <svg width="24" height="24" aria-hidden="true">
                    <use xlink:href="/svg-sprite/sprite.svg#check"></use>
                </svg>
            `;

        // Reset to original icon after 2 seconds
        setTimeout(() => {
          iconWrapper.innerHTML = originalIcon;
        }, 2000);
      })
      .catch((err: unknown) => {
        console.error('Failed to copy:', err);
      });
  });
};
